

// Global elements
var biro_body, biro_win, biro_ajax_spinner;

// Viewport variables
var biro_vw, biro_vw_xs, biro_vw_sm, biro_vw_md, biro_vw_lg, biro_vw_xlg, biro_vw_mobile;


jQuery(function($) {

	// Global vars
	biro_body = $( 'body' );
	biro_win  = $( 'window' );

	// Preload images
	var preload;
	preload = new Image();
	preload.src = biro_main.ajax_spinner_url;

	// Hide stuff that needs to begin hidden with JS
	// (but doesn't use hidden-js class cos it can't be overridden with jQuery.show() etc.)
	$('.hidden-by-js').hide();

	// Fitvids
	$('.fitvids,.content-styles').fitVids();

	// Init viewport variables
	biro_update_viewport_variables();

	// Update viewport on window resize
	$(window).resize(function() {
		waitForFinalEvent(
			function() {
				biro_update_viewport_variables();
			},
			200,
			'viewport-variables'
		);
	});

	// Print
	biro_body.on( 'click', '.button-print', function() {
		window.print();
	});

});



// Function to allow throttled function execution on window resize
var waitForFinalEvent = (function() {
	var timers = {};

	return function(callback, ms, uniqueId) {
		if (!uniqueId) {
			uniqueId = "Don't call this twice without a uniqueId";
		}

		if (timers[uniqueId]) {
			clearTimeout(timers[uniqueId]);
		}

		timers[uniqueId] = setTimeout(callback, ms);
	};
})();



/**
 * Function to set viewport variables
 */
function biro_update_viewport_variables() {
	biro_vw        = window.innerWidth;
	biro_vw_xs     = biro_vw < 576;
	biro_vw_sm     = biro_vw >= 576 && biro_vw < 768;
	biro_vw_md     = biro_vw >= 768 && biro_vw < 992;
	biro_vw_lg     = biro_vw >= 922 && biro_vw < 1200;
	biro_vw_xlg    = biro_vw >= 1200;
	biro_vw_mobile = ( biro_vw_xs || biro_vw_sm || biro_vw_md );
}


/**
 * Get the value of a URL parameter
 *
 * @link https://davidwalsh.name/query-string-javascript
 *
 * @param {string} name
 *
 * @return {string}
 */
function biro_get_url_parameter( name ) {
	name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
	var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
	var results = regex.exec(location.search);
	return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
};